// extracted by mini-css-extract-plugin
export default {"pequeno":"iconesDosModulos_pequeno__+ihq8"};